<div class="avatar-uploader" [class]="'avatar-uploader--' + variant()">
    <div class="avatar-uploader__container">
        <div class="avatar-uploader__profile">
            <div class="avatar-uploader__image-wrapper">
                @if (imagePreviewUrl()) {
                    <img
                        [src]="imagePreviewUrl()"
                        alt="Profile Image"
                        class="avatar-uploader__image"
                        (error)="onImageError()" />
                } @else {
                    <div class="avatar-uploader__placeholder">
                        <svg
                            class="avatar-uploader__placeholder-icon"
                            viewBox="0 0 512 512"
                            aria-hidden="true"
                            focusable="false">
                            <use href="assets/icons/icons-sprite.svg#profile-placeholder"></use>
                        </svg>
                    </div>
                }
            </div>
            @if (isEditable()) {
                <button class="avatar-uploader__edit" type="button">
                    <input
                        type="file"
                        class="avatar-uploader__edit-input"
                        accept="*/*"
                        (change)="onFileChange($event)" />
                    <svg class="avatar-uploader__edit-icon">
                        <use xlink:href="assets/icons/icons-sprite.svg#camera-filled"></use>
                    </svg>
                </button>
            }
        </div>
        @if (variant() === 'default') {
            <div class="avatar-uploader__info">
                <h3 class="avatar-uploader__title">Profile Image</h3>
                <p class="avatar-uploader__subtitle">Click the profile icon to upload new image</p>
            </div>
        }
    </div>
</div>
